import React, { Component } from 'react';
import plusOrange from "../../images/shap/plus-orange.png";
import squareBlue from "../../images/shap/square-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import circleOrange2 from "../../images/shap/circle-orange-2.png";

class testimonialSection extends Component {
	componentDidMount() {
		if (window.elfsight) {
			window.elfsight.mount();
		}
	}

	render() {
		return (
			<section className="section-area section-sp3 testimonial-wraper">
				<div className="container">
					<div className="heading-bx text-center">
						<h6 className="title-ext text-secondary">Testimonios</h6>
						<h2 className="title m-b0">
							Nuestros pacientes
						</h2>
					</div>
					<div className="row justify-content-center">
						<div className="col-lg-8">
							<div className="elfsight-app-103e4247-7726-45b8-a6c6-1bbe6677684c" data-elfsight-app-lazy></div>
						</div>
					</div>
				</div>
				<img className="pt-img1 animate1" src={plusOrange} alt="" />
				<img className="pt-img2 animate2" src={squareBlue} alt="" />
				<img className="pt-img3 animate3" src={circleDots} alt="" />
				<img className="pt-img4 animate4" src={circleOrange2} alt="" />
			</section>
		);
	}
}

export default testimonialSection;
